import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Modal,
  Text
} from "@theorgchartdev/storybook";
import CentralizedModalContainer from "../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import { appstr } from "@coreapp/utils/appstr";
import { UpdateChartMetadata } from "@/Utils/Promises";
import { useToast } from "@/providers/ToastProvider";

type ForceRefreshFormulasModalProps = {
  showReloadFormulasModal: boolean;
  setShowReloadFormulasModal: (show: boolean) => void;
  chartConfig: any;
};

export const ForceRefreshFormulasModal = (props: ForceRefreshFormulasModalProps) => {
  const { showReloadFormulasModal, setShowReloadFormulasModal, chartConfig } = props;

  const { addToast }: any = useToast();

  const onRefreshFormula = async () => {
    // Implement the logic to force refresh the queue here
    const refreshFlag = {
      ...chartConfig?.refreshFlag,
      refreshReason: "Forced formula refresh via Force Formula Refresh Modal (support login)",
      justFormulaRefresh: true,
      needsRefresh: true
    };

    let success;
    try {
      const result = await UpdateChartMetadata(chartConfig.ID, JSON.stringify({ refreshFlag }));
      success = result.success;
    } catch (error) {
      success = false;
    }

    if (success) {
      setShowReloadFormulasModal(false);
      addToast({ message: appstr("Chart added to the refresh queue"), status: "success" });
    } else {
      addToast({ message: appstr("Generic toast error"), status: "error" });
    }
  };

  return (
    <CentralizedModalContainer show={showReloadFormulasModal}>
      <Modal
        show={showReloadFormulasModal}
        id="force-refresh-modal"
        minWidth="small"
        maxWidth="medium"
        centerScreen={true}
      >
        <DialogTitle divider={true} onClose={() => setShowReloadFormulasModal(false)}>
          {`${appstr("Force calculate formulas question")}`}
        </DialogTitle>
        <DialogContent>
          <Flex direction="column" gap="16px" padding="8px">
            <Text size="medium" modifier="medium">
              {appstr("Refresh Formula Info")}
            </Text>
          </Flex>
        </DialogContent>
        <DialogActions>
          <DialogActions.Tertiary onClick={() => setShowReloadFormulasModal(false)}>
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary onClick={onRefreshFormula}>
            {appstr("Force calculate")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
